import React from 'react';
import { workProcess } from '@/data/mock';
import { CheckCircle2 } from 'lucide-react';

const HowWeWorkSection = () => {
  return (
    <section id="how-we-work" className="py-20 md:py-32 bg-accent/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            How We Work
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A transparent, reliable process from inquiry to delivery
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connecting Line */}
            <div className="hidden md:block absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-foreground/20 via-foreground/40 to-foreground/20" />

            {/* Process Steps */}
            <div className="space-y-8">
              {workProcess.map((step, index) => (
                <div
                  key={step.step}
                  className="relative flex items-start gap-6 group"
                  style={{
                    animationDelay: `${index * 100}ms`
                  }}
                >
                  {/* Step Number */}
                  <div className="flex-shrink-0 w-16 h-16 rounded-full bg-foreground dark:bg-amber-600 text-background flex items-center justify-center font-bold text-xl shadow-lg group-hover:scale-110 transition-transform duration-300 z-10">
                    {step.step}
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-background/50 backdrop-blur-sm border border-border/50 rounded-xl p-6 group-hover:shadow-lg group-hover:border-border transition-all duration-300">
                    <h3 className="text-xl font-semibold mb-2 flex items-center gap-2">
                      {step.title}
                      <CheckCircle2 className="h-5 w-5 text-green-500 dark:text-green-400 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </h3>
                    <p className="text-muted-foreground">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
